// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import useLinkBackParameter from "@toolkit/Framework/Common/Hooks/useLinkBackParameter";
import qs from "qs";
import * as React from "react";
import { useSelector } from "react-redux";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";

const OrderCancelNotification = getWidgetComponent("OrderDetails/OrderCancelNotification");

export interface OrderDetailsHeaderProps extends WidgetProps {}

export interface OrderDetailsHeaderStyles {}

export const orderDetailsHeaderStyles: OrderDetailsHeaderStyles = {};

const styles = orderDetailsHeaderStyles;

const OrderDetailsHeader = ({ id }: WidgetProps) => {
    const currentPage = useCurrentPage();
    /* Store Custom Code - Start - MWIAIN-971, preserve order history search terms on back navigation */
    const baseLink = useLinkBackParameter(
        constants.pageType.orderHistory,
        useAppSelector(state => state.pages.orderHistory.getOrdersParameter),
    );

    const getOrdersParameter = useSelector((state: ApplicationState) => state.pages.orderHistory.getOrdersParameter);

    const linkBack = React.useMemo(() => {
        if (!baseLink) {
            return baseLink;
        }
        const queryString = qs.stringify(getOrdersParameter);
        return {
            ...baseLink,
            url: queryString ? `${baseLink.url}?${queryString}` : baseLink.url,
        };
    }, [baseLink, getOrdersParameter]);
    /* Store Custom Code - End - MWIAIN-971, preserve order history search terms on back navigation */

    return (
        <OrderHeader
            title={currentPage.fields.title}
            linkBack={linkBack}
            message={OrderCancelNotification ? <OrderCancelNotification /> : undefined /* Store Custom Code */}
        >
            <Zone contentId={id} zoneName="ActionButtons" />
        </OrderHeader>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsHeader,
    definition: {
        group: "Order Details",
        displayName: "Header",
        allowedContexts: ["OrderDetailsPage"],
    },
};

export default widgetModule;
